import apiClient from '../apiClient';
import { GET_PAYMENT_METHOD_CHOICE_LIST } from '../apiUrl';

const getPaymentMethodChoiceListApi = () => {
  return apiClient.get(GET_PAYMENT_METHOD_CHOICE_LIST);
};

export default getPaymentMethodChoiceListApi;
